// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xB-z","smallCardRow":"yB-z","largeCardRow":"zB-z","productSearchRow":"AB-z","curatedRow":"BB-z"};